import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://bcs-us.com';
const SITE_NAME = 'BCS - Coating & Repair Services';
const DEFAULT_IMAGE = `${SITE_URL}/bcs-logo.png`;

const SEO = ({ title, description, path = '', keywords = [], type = 'website', noindex = false }) => {
  const fullTitle = title ? `${title} | BCS` : 'BCS - Coatings and Repair Services for Assets & Infrastructure';
  const fullUrl = `${SITE_URL}${path}`;
  const metaDescription = description || 'BCS is a WBENC certified industrial coating contractor and corrosion repair specialist. Tank coating, water tank lining, wastewater coatings, clarifier repair, secondary containment, epoxy repair systems, and infrastructure rehabilitation. Serving California, Arizona, Nevada & Texas.';

  const defaultKeywords = [
    'industrial coating contractor',
    'tank coating contractor',
    'water tank lining contractor',
    'corrosion repair contractor',
    'wastewater coating contractor',
    'epoxy repair systems',
    'protective coatings contractor',
    'clarifier coating repair',
    'secondary containment coatings',
    'infrastructure rehabilitation contractor',
    'industrial coating contractor California',
    'corrosion repair contractor California',
    'BCS'
  ];

  const allKeywords = [...new Set([...keywords, ...defaultKeywords])].join(', ');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={allKeywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />

      {/* Geo */}
      <meta name="geo.region" content="US-CA" />
      <meta name="geo.placename" content="California" />
    </Helmet>
  );
};

export default SEO;
